import { Component, OnInit, Input } from "@angular/core";
import { Question } from "src/app/Models/question.interface";
import { ProfileComponent } from "../profile/profile.component";

@Component({
  selector: "question-editor",
  templateUrl: "./question-editor.component.html",
  styleUrls: ["./question-editor.component.css"],
})
export class QuestionEditorComponent implements OnInit {
  @Input() question: Question;
  @Input() profile: ProfileComponent;
  constructor() {}

  ngAfterViewInit() {
    console.log(this.question);
  }
  ngOnInit(): void {}
}
